import ReactGA from 'react-ga'

export const initGA = () => {
  const { REACT_APP_SHOPMATIC_GOOGLE_ANALYTICS_ID } = process.env

  ReactGA.initialize(REACT_APP_SHOPMATIC_GOOGLE_ANALYTICS_ID)
}

export const gaPageView = () => {
  ReactGA.pageview(window.location.pathname)
}

export const fireEvent = (params) => {
  ReactGA.event(params)
}

export const ClickedOntrack = (orderId) => {
  fireEvent({
    category: 'Bifrost',
    action: 'ClickedOntrack',
    label: orderId,
  })
}

export const ClickedOntrackinglink = (orderId, status) => {
  fireEvent({
    category: 'Bifrost',
    action: 'ClickedOntrackinglink',
    label: `${orderId} | ${status}`,
  })
}
